// extracted by mini-css-extract-plugin
export default {"container":"RockAnim_container__OQm+T","squash":"RockAnim_squash__bpED+","shake":"RockAnim_shake__HDptB","rock":"RockAnim_rock__1brHU","jump":"RockAnim_jump__JLDKy"};